 //时间字符串处理 parseISO8601 为了兼容性ie7

var time = {
timeFormat: function(fmt) { //author: meizz 
  var o = {
      "M+": this.getMonth() + 1, //月份 
      "d+": this.getDate(), //日 
      "h+": this.getHours(), //小时 
      "m+": this.getMinutes(), //分 
      "s+": this.getSeconds(), //秒 
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度 
      "S": this.getMilliseconds() //毫秒 
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
  if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
 },
parseISO8601: function(dateStringInRange) {  
   var isoExp = /^\s*(\d{4})-(\d\d)-(\d\d)\s*$/,  
       date = new Date(NaN), month,  
       parts = isoExp.exec(dateStringInRange);  
  
   if(parts) {  
     month = +parts[2];  
     date.setFullYear(parts[1], month - 1, parts[3]);  
     if(month != date.getMonth() + 1) {  
       date.setTime(NaN);  
     }  
   }  
   return date;  
},
getServerTime: function() { //获取服务器时间
  var xmlHttp = false;
  try {
    xmlHttp = new ActiveXObject("Msxml2.XMLHTTP");
  } catch (e) {
    try {
      xmlHttp = new ActiveXObject("Microsoft.XMLHTTP");
    } catch (e2) {
      xmlHttp = false;
    }
  }

  if (!xmlHttp && typeof XMLHttpRequest != 'undefined') {
    xmlHttp = new XMLHttpRequest();
  }

  xmlHttp.open("GET", "/images/blank.gif?rnd=" + (new Date()).getTime(), false);
  //xmlHttp.setRequestHeader("Range", "bytes=-1");
  xmlHttp.send();

  severtime = new Date(xmlHttp.getResponseHeader("Date"));
  return severtime;
},
isDealTime: function() { //现在是否是交易时间
  var inputtime = window.servertime;
  if(inputtime == null) return true;
  if (inputtime.getDay() == 6 || inputtime.getDay() == 0) return false;
  if (inputtime.getHours() >= 15 || inputtime.getHours() < 9) return false;
  return true;
},
initServerTime: function(){
    window.servertime = time.getServerTime();
    setInterval(function(){
      window.servertime.setTime(window.servertime.getTime() + 5000);
    },5000);
}
}

  // window.servertime = time.getServerTime();
  // setInterval(function(){
  //   window.servertime.setTime(window.servertime.getTime() + 5000);
  // },5000);

module.exports=time


//////////////////
// WEBPACK FOOTER
// ./src/module/helper/time.js
// module id = 10
// module chunks = 0